// extracted by mini-css-extract-plugin
export default {"companyFormWidget":"CompanyFormWidget_companyFormWidget__ztTO3","buttonts":"CompanyFormWidget_buttonts__tXXUG"};